import { createBrowserHistory } from 'history';
import { ROUTER_ROOT } from './secrets';

type Callback = (value: boolean) => void;

const getUserConfirmation = (location: string, callback: Callback) => {
  const [newUrl, action] = location.split('|');

  // Check if user wants to navigate to the same page.
  // If so, we don't want to trigger the page transitions.
  // We have to check the `action`, because the pathnames
  // are the same when going back in history 🤷‍
  const currentUrl = `${window.location.pathname}${window.location.search}`;
  if (newUrl === currentUrl && action === 'PUSH') {
    callback(false);
    return;
  }

  callback(true);
};

// ...

const history = createBrowserHistory({
  basename: ROUTER_ROOT,
  getUserConfirmation,
});

// `block` must return a string to conform.
// We send both the pathname and action to `getUserConfirmation`.
history.block((location, action) => {
  return `${location.pathname}${location.search}|${action}`;
});

export default history;
